import type { Anime, CategoryItem } from "@/types/anime";

export const animeList: Anime[] = [
  {
    id: "yozakura-vow",
    title: "夜樱之誓",
    originalTitle: "夜桜の誓い",
    cover: "https://readdy.ai/api/search-image?query=A%20lone%20young%20woman%20in%20a%20flowing%20dark%20kimono%20standing%20under%20a%20blooming%20night%20cherry%20tree%2C%20falling%20petals%20lit%20by%20paper%20lanterns%2C%20elegant%20anime%20key%20visual%2C%20cinematic%20moody%20lighting%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20highly%20detailed%20digital%20illustration%2C%20no%20text&width=600&height=900&seq=anime-cover-01&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20anime%20scene%20of%20a%20moonlit%20shrine%20courtyard%20with%20night%20cherry%20blossoms%2C%20a%20distant%20female%20silhouette%20in%20a%20dark%20kimono%2C%20paper%20lanterns%20glowing%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20painterly%20detailed%20digital%20illustration%2C%20no%20text&width=1600&height=900&seq=anime-banner-01&orientation=landscape",
    synopsis: "樱花只在一夜盛放，而她只剩下七个夜晚。一段被诅咒的誓约，让两位陌生人在月下重逢。",
    description: "传说中，夜樱盛放的第七夜，许下的誓言会被神明听见，也会被神明夺走。见习巫女绫音在神社的旧箱中发现一封写给自己名字的信，落款却是一百年前。\n\n循着信中的指引，她遇见了自称「守夜人」的青年。他记得每一场樱花的凋落，却记不得自己的名字。两人在七个夜晚里交换秘密，也逐渐接近一个被神社刻意掩埋的真相。\n\n这是一部关于记忆、承诺与放手的成人向剧情作品，以克制的叙事与浓烈的画面，描绘一段注定无法被记录的爱恋。",
    tags: ["和风奇幻", "宿命", "悬疑", "月下"],
    category: "奇幻",
    region: "日本",
    year: 2025,
    status: "连载中",
    episodes: 12,
    rating: 9.2,
    author: "柊木澪",
    studio: "月白动画",
    updatedAt: "2026-10-16",
    views: 184200,
    featured: true,
  },
  {
    id: "scarlet-boundary",
    title: "绯色边界",
    originalTitle: "スカーレット・バウンダリー",
    cover: "https://readdy.ai/api/search-image?query=A%20confident%20female%20swordswoman%20with%20crimson%20ribbons%20in%20her%20hair%2C%20holding%20a%20glowing%20blade%20in%20a%20burning%20city%20alley%2C%20elegant%20anime%20key%20visual%2C%20cinematic%20moody%20lighting%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20highly%20detailed%20digital%20illustration%2C%20no%20text&width=600&height=900&seq=anime-cover-02&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20anime%20battlefield%20at%20dusk%2C%20a%20female%20warrior%20with%20a%20glowing%20crimson%20blade%20facing%20an%20armored%20figure%20amid%20embers%20and%20smoke%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20painterly%20detailed%20digital%20illustration%2C%20no%20text&width=1600&height=900&seq=anime-banner-02&orientation=landscape",
    synopsis: "两个王朝的边境线上，她握着一把会吞噬主人记忆的刀。斩落敌人，也斩落自己。",
    description: "绯色边界是大陆上唯一一条不属于任何国家的界线。守界人必须以记忆为代价挥剑，每斩杀一名入侵者，就会遗忘一段最珍贵的过往。\n\n少女露娜继承了母亲的刀，也继承了母亲未完成的任务。她身边只有一位不肯说出姓名的随从，以及一本被撕去半数页面的日记。\n\n当敌国的将军提出停战，她第一次开始怀疑：这场持续百年的战争，究竟是为了守护边界，还是为了让某些人永远不被记起。",
    tags: ["战斗", "女性主角", "政治", "悲剧"],
    category: "动作",
    region: "日本",
    year: 2026,
    status: "连载中",
    episodes: 24,
    rating: 9.0,
    author: "黑川遥",
    studio: "赤羽制作",
    updatedAt: "2026-10-18",
    views: 231500,
    featured: true,
  },
  {
    id: "moonlit-pact",
    title: "月下契约",
    originalTitle: "月光の契約",
    cover: "https://readdy.ai/api/search-image?query=An%20elegant%20silver-haired%20sorceress%20in%20an%20ornate%20black%20gown%20summoning%20golden%20runes%20inside%20a%20gothic%20observatory%2C%20elegant%20anime%20key%20visual%2C%20cinematic%20moody%20lighting%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20highly%20detailed%20digital%20illustration%2C%20no%20text&width=600&height=900&seq=anime-cover-03&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20anime%20interior%20of%20a%20vast%20gothic%20observatory%20with%20floating%20golden%20runes%2C%20a%20silver-haired%20sorceress%20seen%20from%20behind%20before%20a%20huge%20moonlit%20window%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20painterly%20detailed%20digital%20illustration%2C%20no%20text&width=1600&height=900&seq=anime-banner-03&orientation=landscape",
    synopsis: "她与月亮签下契约，换来无所不能的魔法，代价是永远不能被任何人爱上。",
    description: "王立魔法学院的最高塔上，住着一位从不参加舞会的魔女。传说她的魔法足以扭转天象，却从不为自己使用一次。\n\n新来的年轻讲师受命调查她，却在每一次深夜的观测里，发现她正悄悄把月亮推向更远的地方。\n\n一部关于孤独与救赎的奇幻作品，用华丽的美术与层层递进的谜题，讲述一个不肯被爱的人如何学会接受温柔。",
    tags: ["魔法", "学院", "禁忌", "治愈"],
    category: "奇幻",
    region: "日本",
    year: 2025,
    status: "已完结",
    episodes: 13,
    rating: 8.8,
    author: "白鸟言葉",
    studio: "月白动画",
    updatedAt: "2026-09-28",
    views: 157800,
    featured: true,
  },
  {
    id: "deep-sea-echo",
    title: "深海回声",
    originalTitle: "深海のエコー",
    cover: "https://readdy.ai/api/search-image?query=A%20mysterious%20diver%20girl%20in%20a%20dark%20wetsuit%20floating%20in%20deep%20water%20surrounded%20by%20glowing%20jellyfish%2C%20elegant%20anime%20key%20visual%2C%20cinematic%20moody%20lighting%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20highly%20detailed%20digital%20illustration%2C%20no%20text&width=600&height=900&seq=anime-cover-04&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20underwater%20anime%20scene%20of%20a%20sunken%20crimson%20temple%20lit%20by%20swarms%20of%20glowing%20jellyfish%2C%20a%20small%20diver%20silhouette%20descending%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20painterly%20detailed%20digital%20illustration%2C%20no%20text&width=1600&height=900&seq=anime-banner-04&orientation=landscape",
    synopsis: "每逢满月，海底会传来一段熟悉的旋律。那是三年前失踪的姐姐，留给她的唯一线索。",
    description: "海洋研究船「回声号」在午夜收到一段无法解析的录音，频率与三年前失踪的考察队完全一致。\n\n潜水员汐音申请加入调查，只为找到姐姐留下的痕迹。随着下潜深度增加，她开始听见只有自己能听见的歌声，也开始怀疑这段旋律是否来自人类。\n\n本作以压迫感极强的水下镜头与克制的配乐，构建出一个既浪漫又令人窒息的深海世界。",
    tags: ["悬疑", "海洋", "姐妹", "科幻"],
    category: "悬疑",
    region: "日本",
    year: 2026,
    status: "连载中",
    episodes: 12,
    rating: 9.1,
    author: "海野灯",
    studio: "潮汐工作室",
    updatedAt: "2026-10-15",
    views: 142300,
    featured: false,
  },
  {
    id: "rose-cage",
    title: "蔷薇牢笼",
    originalTitle: "薔薇の檻",
    cover: "https://readdy.ai/api/search-image?query=A%20striking%20woman%20in%20a%20deep%20wine%20evening%20dress%20standing%20inside%20a%20gilded%20cage%20filled%20with%20dark%20red%20roses%2C%20elegant%20anime%20key%20visual%2C%20cinematic%20moody%20lighting%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20highly%20detailed%20digital%20illustration%2C%20no%20text&width=600&height=900&seq=anime-cover-05&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20anime%20ballroom%20with%20crimson%20roses%20and%20candlelight%2C%20an%20elegant%20woman%20in%20a%20wine%20dress%20standing%20apart%20from%20a%20crowd%20of%20silhouettes%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20painterly%20detailed%20digital%20illustration%2C%20no%20text&width=1600&height=900&seq=anime-banner-05&orientation=landscape",
    synopsis: "她嫁给了一个只爱她容貌的家族。直到某个深夜，她在镜子里看见了另一个自己。",
    description: "十九世纪的旧都，落魄贵族之女艾琳被安排嫁入以蔷薇为纹章的豪门。华丽的宅邸里，每个房间都锁着一段不能说的往事。\n\n白天她是完美的夫人，夜里她在镜中与另一个自己对话。那个自己更聪明、更冷酷，也更清楚这座宅邸真正的主人是谁。\n\n这是一部成人向心理剧情作品，用精致的时代美术与缓慢推进的张力，剖开一段被体面包裹的婚姻。",
    tags: ["时代剧", "心理", "女性主角", "反转"],
    category: "剧情",
    region: "日本",
    year: 2024,
    status: "已完结",
    episodes: 10,
    rating: 8.9,
    author: "远野沙罗",
    studio: "绯月映画",
    updatedAt: "2026-08-20",
    views: 198600,
    featured: false,
  },
  {
    id: "silver-wing-hunt",
    title: "银翼追猎",
    originalTitle: "シルバーウィング",
    cover: "https://readdy.ai/api/search-image?query=A%20cool%20female%20pilot%20in%20a%20sleek%20silver%20flight%20suit%20standing%20before%20a%20crimson%20fighter%20jet%20in%20a%20hangar%2C%20elegant%20anime%20key%20visual%2C%20cinematic%20moody%20lighting%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20highly%20detailed%20digital%20illustration%2C%20no%20text&width=600&height=900&seq=anime-cover-06&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20anime%20sky%20battle%20above%20a%20storm%20cloud%20layer%2C%20silver%20fighter%20jets%20trailing%20crimson%20smoke%2C%20sunset%20gold%20light%20on%20metal%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20painterly%20detailed%20digital%20illustration%2C%20no%20text&width=1600&height=900&seq=anime-banner-06&orientation=landscape",
    synopsis: "天空只剩最后一条航线，而她是唯一还敢起飞的人。",
    description: "大气层被永久性尘云覆盖的第三十年，人类依靠高空航线维系城市之间的联系。退役飞行员莉娜被召回，任务是护送一架不该存在的运输机。\n\n她很快发现，同行的人各有秘密，而航线尽头等待她的，是十年前那场事故的真相。\n\n高密度空战分镜与机械细节是本作最大看点，同时保留了充足的人物情感线索。",
    tags: ["空战", "机械", "末世", "女性主角"],
    category: "动作",
    region: "日本",
    year: 2025,
    status: "连载中",
    episodes: 18,
    rating: 8.7,
    author: "鹰栖凉",
    studio: "赤羽制作",
    updatedAt: "2026-10-12",
    views: 121400,
    featured: false,
  },
  {
    id: "stardust-theory",
    title: "星屑恋爱论",
    originalTitle: "星屑恋愛論",
    cover: "https://readdy.ai/api/search-image?query=A%20shy%20high%20school%20girl%20in%20a%20dark%20uniform%20holding%20a%20telescope%20under%20a%20starry%20sky%20on%20a%20school%20rooftop%2C%20elegant%20anime%20key%20visual%2C%20cinematic%20moody%20lighting%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20highly%20detailed%20digital%20illustration%2C%20no%20text&width=600&height=900&seq=anime-cover-07&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20anime%20school%20rooftop%20at%20night%20with%20a%20telescope%20and%20two%20students%20sitting%20apart%2C%20immense%20starry%20sky%20with%20a%20faint%20crimson%20nebula%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20painterly%20detailed%20digital%20illustration%2C%20no%20text&width=1600&height=900&seq=anime-banner-07&orientation=landscape",
    synopsis: "天文社只剩两个人，一个是她，一个是她暗恋三年却从未说过话的同桌。",
    description: "县立高中天文社面临废社，唯一留下的社员千夏必须在暑假前凑齐五名成员。她找上的第一个人，是总在放学后独自留在教室的少年。\n\n两人以「观测记录」为名，开始每个夜晚的相处。他们谈论星体、距离与光年，却始终绕不开那句最简单的告白。\n\n一部细腻的校园恋爱作品，节奏舒缓，情绪克制，适合喜欢慢热叙事的观众。",
    tags: ["校园", "恋爱", "青春", "慢热"],
    category: "校园",
    region: "日本",
    year: 2026,
    status: "连载中",
    episodes: 12,
    rating: 9.3,
    author: "小野寺葵",
    studio: "晴空动画",
    updatedAt: "2026-10-17",
    views: 168900,
    featured: false,
  },
  {
    id: "midnight-bookstore",
    title: "黑猫与午夜书店",
    originalTitle: "黒猫と真夜中の本屋",
    cover: "https://readdy.ai/api/search-image?query=A%20cozy%20old%20bookstore%20at%20midnight%20with%20a%20black%20cat%20sitting%20on%20a%20stack%20of%20antique%20books%2C%20warm%20lantern%20light%2C%20elegant%20anime%20key%20visual%2C%20cinematic%20moody%20lighting%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20highly%20detailed%20digital%20illustration%2C%20no%20text&width=600&height=900&seq=anime-cover-08&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20anime%20interior%20of%20a%20narrow%20midnight%20bookstore%20with%20floor%20to%20ceiling%20shelves%2C%20a%20black%20cat%20on%20the%20counter%2C%20warm%20amber%20lanterns%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20painterly%20detailed%20digital%20illustration%2C%20no%20text&width=1600&height=900&seq=anime-banner-08&orientation=landscape",
    synopsis: "这家书店只在午夜开门，只借书给睡不着的人，而店长是一只不太礼貌的黑猫。",
    description: "城市最深的小巷里，有一家没有招牌的旧书店。午夜十二点，门会自动打开，一只黑猫坐在柜台上，等着替客人挑选一本「今晚需要的书」。\n\n失眠的上班族、失恋的调酒师、不愿回家的学生，每个人都在这里读到一段与自己有关的故事。\n\n单元剧结构的治愈系作品，画面温暖，节奏松弛，适合深夜观看。",
    tags: ["治愈", "单元剧", "奇幻", "猫咪"],
    category: "治愈",
    region: "日本",
    year: 2025,
    status: "已完结",
    episodes: 12,
    rating: 9.4,
    author: "猫町铃",
    studio: "晴空动画",
    updatedAt: "2026-07-30",
    views: 205700,
    featured: false,
  },
  {
    id: "glass-heart-frequency",
    title: "玻璃心频率",
    originalTitle: "ガラスの心拍数",
    cover: "https://readdy.ai/api/search-image?query=A%20young%20female%20singer%20with%20headphones%20standing%20in%20a%20recording%20studio%20lit%20by%20crimson%20neon%2C%20reflections%20on%20glass%2C%20elegant%20anime%20key%20visual%2C%20cinematic%20moody%20lighting%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20highly%20detailed%20digital%20illustration%2C%20no%20text&width=600&height=900&seq=anime-cover-09&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20anime%20scene%20of%20an%20empty%20concert%20hall%20with%20a%20single%20spotlight%20and%20a%20girl%20holding%20a%20microphone%2C%20crimson%20curtains%20and%20gold%20trim%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20painterly%20detailed%20digital%20illustration%2C%20no%20text&width=1600&height=900&seq=anime-banner-09&orientation=landscape",
    synopsis: "她写的每首歌都会成真，可她最想实现的那一首，从来不敢写完。",
    description: "独立音乐人澪拥有一项没人知道的能力：她写下的歌词，会以某种方式在现实中发生。\n\n十九岁那年，她写下了一首关于离别的歌，第二天，最重要的人就从她的生活里消失了。从此她只写别人的故事，再也不碰自己的心。\n\n直到某天，一个不懂音乐的录音师告诉她：「你这首歌，缺最后一句。」",
    tags: ["音乐", "恋爱", "都市", "奇幻"],
    category: "爱情",
    region: "日本",
    year: 2026,
    status: "连载中",
    episodes: 12,
    rating: 8.8,
    author: "音无奏",
    studio: "绯月映画",
    updatedAt: "2026-10-14",
    views: 132600,
    featured: false,
  },
  {
    id: "fog-city-case",
    title: "雾都谜案",
    originalTitle: "霧の都の事件簿",
    cover: "https://readdy.ai/api/search-image?query=A%20detective%20woman%20in%20a%20long%20dark%20coat%20and%20hat%20standing%20on%20a%20foggy%20gaslit%20street%2C%20vintage%20lamps%20and%20wet%20cobblestone%2C%20elegant%20anime%20key%20visual%2C%20cinematic%20moody%20lighting%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20highly%20detailed%20digital%20illustration%2C%20no%20text&width=600&height=900&seq=anime-cover-10&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20anime%20foggy%20Victorian%20city%20street%20at%20night%2C%20a%20female%20detective%20silhouette%20walking%20past%20gas%20lamps%2C%20crimson%20coach%20in%20the%20distance%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20painterly%20detailed%20digital%20illustration%2C%20no%20text&width=1600&height=900&seq=anime-banner-10&orientation=landscape",
    synopsis: "雾散之前，真相不会出现。而她只有四个小时。",
    description: "工业时代的旧都终年被浓雾笼罩，罪案在雾里发生，也在雾里被掩埋。\n\n女侦探薇拉受托寻找一枚失踪的怀表，却在追查中卷进一场牵连整座城市的阴谋。每一条线索都指向同一个名字，而那个名字属于她已故的父亲。\n\n本作以强氛围的美术与严密的推理链条见长，适合偏爱古典悬疑的观众。",
    tags: ["推理", "悬疑", "时代剧", "女性主角"],
    category: "悬疑",
    region: "日本",
    year: 2024,
    status: "已完结",
    episodes: 16,
    rating: 8.6,
    author: "雾岛透",
    studio: "潮汐工作室",
    updatedAt: "2026-06-18",
    views: 174800,
    featured: false,
  },
  {
    id: "forbidden-garden",
    title: "禁忌花园",
    originalTitle: "禁じられた花園",
    cover: "https://readdy.ai/api/search-image?query=A%20beautiful%20woman%20in%20a%20dark%20lace%20dress%20standing%20in%20an%20overgrown%20garden%20of%20crimson%20flowers%20at%20dusk%2C%20elegant%20anime%20key%20visual%2C%20cinematic%20moody%20lighting%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20highly%20detailed%20digital%20illustration%2C%20no%20text&width=600&height=900&seq=anime-cover-11&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20anime%20scene%20of%20a%20secluded%20manor%20garden%20overflowing%20with%20crimson%20flowers%20at%20dusk%2C%20a%20woman%20in%20a%20dark%20lace%20dress%20on%20a%20stone%20path%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20painterly%20detailed%20digital%20illustration%2C%20no%20text&width=1600&height=900&seq=anime-banner-11&orientation=landscape",
    synopsis: "花园每年只开一次，每次只为一个客人。而这一次，来的人是她妹妹的未婚夫。",
    description: "被家族软禁在北境庄园的少女，唯一被允许的活动是照料花园。母亲告诉她，花园里的每一株花，都埋着一段不能提起的往事。\n\n妹妹的婚礼筹备让庄园重新热闹起来。未婚夫循着花香误入禁区，看见了她从未对外人展示的世界。\n\n成人向情感剧情作品，以极致的画面质感与暧昧的叙事距离，描写一段注定不被允许的关系。",
    tags: ["情感", "成人向", "家族", "禁忌"],
    category: "爱情",
    region: "日本",
    year: 2025,
    status: "已完结",
    episodes: 10,
    rating: 8.5,
    author: "能登紫苑",
    studio: "绯月映画",
    updatedAt: "2026-08-08",
    views: 216300,
    featured: false,
  },
  {
    id: "daylight-fireworks",
    title: "白昼焰火",
    originalTitle: "昼の花火",
    cover: "https://readdy.ai/api/search-image?query=A%20teenage%20girl%20in%20a%20summer%20uniform%20standing%20on%20a%20seaside%20bridge%20under%20a%20bright%20hazy%20sky%2C%20crimson%20ribbon%20in%20her%20hair%2C%20elegant%20anime%20key%20visual%2C%20cinematic%20moody%20lighting%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20highly%20detailed%20digital%20illustration%2C%20no%20text&width=600&height=900&seq=anime-cover-12&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20anime%20seaside%20town%20in%20midsummer%2C%20railway%20bridge%20and%20empty%20street%2C%20sunlight%20through%20power%20lines%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20painterly%20detailed%20digital%20illustration%2C%20no%20text&width=1600&height=900&seq=anime-banner-12&orientation=landscape",
    synopsis: "那个夏天他们约定，要在白天放一场没有人看得见的焰火。",
    description: "海边小镇的夏天总是很长。四个即将毕业的高中生决定在离校前完成一件「毫无意义但必须做」的事——在白天的天空里放一场焰火。\n\n他们找材料、躲老师、争吵又和好，在过程中慢慢意识到，有些关系一旦毕业就会结束。\n\n青春群像作品，用明亮的画面与细碎的日常，记录一段无法复制的夏天。",
    tags: ["青春", "群像", "夏天", "成长"],
    category: "校园",
    region: "日本",
    year: 2025,
    status: "已完结",
    episodes: 12,
    rating: 9.0,
    author: "夏川悠",
    studio: "晴空动画",
    updatedAt: "2026-07-12",
    views: 149200,
    featured: false,
  },
  {
    id: "twin-phantom-night",
    title: "双子幻夜",
    originalTitle: "双子の幻夜",
    cover: "https://readdy.ai/api/search-image?query=Two%20identical%20young%20women%20in%20mirrored%20dark%20dresses%20standing%20back%20to%20back%20in%20a%20candlelit%20hall%20of%20mirrors%2C%20elegant%20anime%20key%20visual%2C%20cinematic%20moody%20lighting%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20highly%20detailed%20digital%20illustration%2C%20no%20text&width=600&height=900&seq=anime-cover-13&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20anime%20hall%20of%20mirrors%20lit%20by%20hundreds%20of%20candles%2C%20two%20identical%20silhouettes%20reflected%20infinitely%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20painterly%20detailed%20digital%20illustration%2C%20no%20text&width=1600&height=900&seq=anime-banner-13&orientation=landscape",
    synopsis: "镜子里的人先动了手。从那天起，她们开始交换人生。",
    description: "双胞胎姐妹从小被教导：不可以同时出现在同一个房间。\n\n十八岁生日那天，妹妹在镜前许愿，希望自己能成为姐姐。第二天醒来，她发现自己真的站在了姐姐的位置上，而镜子里的人，正微笑着看着她。\n\n一部结构精巧的奇幻悬疑剧，用对称构图与反复反转，讨论身份与欲望的边界。",
    tags: ["双子", "悬疑", "镜像", "反转"],
    category: "奇幻",
    region: "日本",
    year: 2026,
    status: "连载中",
    episodes: 12,
    rating: 8.9,
    author: "镜见灯",
    studio: "月白动画",
    updatedAt: "2026-10-11",
    views: 118700,
    featured: false,
  },
  {
    id: "neon-lost",
    title: "霓虹迷途",
    originalTitle: "ネオン・ロスト",
    cover: "https://readdy.ai/api/search-image?query=A%20young%20woman%20with%20a%20short%20black%20bob%20and%20a%20red%20jacket%20standing%20in%20a%20rainy%20neon%20alley%20of%20a%20futuristic%20city%2C%20elegant%20anime%20key%20visual%2C%20cinematic%20moody%20lighting%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20highly%20detailed%20digital%20illustration%2C%20no%20text&width=600&height=900&seq=anime-cover-14&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20anime%20cyberpunk%20city%20street%20in%20heavy%20rain%2C%20crimson%20and%20gold%20neon%20signs%20reflected%20on%20wet%20asphalt%2C%20tiny%20figure%20walking%20alone%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20painterly%20detailed%20digital%20illustration%2C%20no%20text&width=1600&height=900&seq=anime-banner-14&orientation=landscape",
    synopsis: "在这座城市里，记忆可以买卖。而她刚好卖掉了最重要的一段。",
    description: "新港市的地下市场流通着一种商品：他人的记忆。富人购买体验，穷人出售过往。\n\n送货员七海每天穿梭在霓虹与雨里，直到某天她送出的记忆芯片里，出现了自己的脸。\n\n赛博朋克风格的成人向作品，画面浓烈，叙事凌厉，讨论记忆是否等同于灵魂。",
    tags: ["赛博朋克", "科幻", "记忆", "都市"],
    category: "动作",
    region: "韩国",
    year: 2026,
    status: "连载中",
    episodes: 12,
    rating: 8.7,
    author: "雨宫零",
    studio: "赤羽制作",
    updatedAt: "2026-10-09",
    views: 96300,
    featured: false,
  },
  {
    id: "confession-after-rain",
    title: "雨后告白",
    originalTitle: "雨上がりの告白",
    cover: "https://readdy.ai/api/search-image?query=A%20young%20couple%20sharing%20one%20umbrella%20on%20a%20quiet%20rainy%20street%20at%20dusk%2C%20warm%20shop%20lights%2C%20elegant%20anime%20key%20visual%2C%20cinematic%20moody%20lighting%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20highly%20detailed%20digital%20illustration%2C%20no%20text&width=600&height=900&seq=anime-cover-15&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20anime%20rainy%20evening%20street%20with%20warm%20shop%20windows%2C%20two%20figures%20under%20a%20single%20umbrella%20walking%20away%2C%20reflections%20on%20wet%20pavement%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20painterly%20detailed%20digital%20illustration%2C%20no%20text&width=1600&height=900&seq=anime-banner-15&orientation=landscape",
    synopsis: "她准备了三年告白台词，却在一场大雨里全部忘光。",
    description: "在东京工作的设计师美咲，暗恋同栋楼的咖啡师整整三年。她写了一份完美的告白计划，包括天气、台词与退路。\n\n计划执行当天，一场突如其来的暴雨打乱了一切。躲雨的屋檐下，对方先开了口。\n\n一部成年人的恋爱作品，没有夸张的戏剧冲突，只有恰到好处的犹豫与勇气。",
    tags: ["都市恋爱", "成年人", "治愈", "日常"],
    category: "爱情",
    region: "中国",
    year: 2025,
    status: "已完结",
    episodes: 8,
    rating: 9.1,
    author: "榊原澄",
    studio: "晴空动画",
    updatedAt: "2026-09-05",
    views: 187400,
    featured: false,
  },
  {
    id: "butterfly-box",
    title: "蝶影之匣",
    originalTitle: "蝶の匣",
    cover: "https://readdy.ai/api/search-image?query=A%20pale%20girl%20in%20a%20dark%20high%20collared%20dress%20holding%20a%20glass%20display%20box%20with%20glowing%20crimson%20butterflies%20inside%2C%20elegant%20anime%20key%20visual%2C%20cinematic%20moody%20lighting%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20highly%20detailed%20digital%20illustration%2C%20no%20text&width=600&height=900&seq=anime-cover-16&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20anime%20room%20filled%20with%20glass%20display%20cases%20and%20hundreds%20of%20crimson%20butterfly%20specimens%2C%20a%20solitary%20girl%20by%20a%20window%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20painterly%20detailed%20digital%20illustration%2C%20no%20text&width=1600&height=900&seq=anime-banner-16&orientation=landscape",
    synopsis: "收藏家收集的不是蝴蝶，而是每一个临死前许下的愿望。",
    description: "山中的洋馆里住着一位从不外出的收藏家，她的藏品是数不清的蝴蝶标本。\n\n为了替病重的弟弟求医，少女千景成为她的助手。她很快发现，每只蝴蝶的翅膀上都写着一个人的名字，而那些人都还没有死。\n\n一部带有强烈视觉象征的悬疑作品，探讨欲望、交换与代价。",
    tags: ["悬疑", "猎奇", "象征", "少女"],
    category: "悬疑",
    region: "日本",
    year: 2024,
    status: "已完结",
    episodes: 10,
    rating: 8.4,
    author: "柊木澪",
    studio: "潮汐工作室",
    updatedAt: "2026-05-22",
    views: 138500,
    featured: false,
  },
  {
    id: "amber-dusk",
    title: "琥珀色黄昏",
    originalTitle: "琥珀の夕暮れ",
    cover: "https://readdy.ai/api/search-image?query=A%20weary%20but%20elegant%20woman%20in%20a%20cream%20coat%20standing%20on%20an%20empty%20train%20platform%20at%20sunset%2C%20dust%20in%20golden%20light%2C%20elegant%20anime%20key%20visual%2C%20cinematic%20moody%20lighting%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20highly%20detailed%20digital%20illustration%2C%20no%20text&width=600&height=900&seq=anime-cover-17&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20anime%20empty%20country%20train%20platform%20at%20golden%20hour%2C%20one%20traveler%20with%20a%20suitcase%2C%20overgrown%20rails%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20painterly%20detailed%20digital%20illustration%2C%20no%20text&width=1600&height=900&seq=anime-banner-17&orientation=landscape",
    synopsis: "三十岁那年，她辞掉工作，回到没有一班列车停靠的小站。",
    description: "在一线城市打拼十年的女性回到故乡，只为处理父亲留下的旧房子。\n\n房子比她记忆中更小，邻居比她记忆中更老，而她自己，似乎也不确定还想成为什么样的人。\n\n一部安静的成人向生活剧，用大量留白与日常对话，讲述重新开始这件事有多难，又有多值得。",
    tags: ["生活", "治愈", "女性成长", "故乡"],
    category: "剧情",
    region: "中国",
    year: 2026,
    status: "连载中",
    episodes: 10,
    rating: 9.2,
    author: "森下千寻",
    studio: "绯月映画",
    updatedAt: "2026-10-08",
    views: 109200,
    featured: false,
  },
  {
    id: "snow-letter",
    title: "雪国信笺",
    originalTitle: "雪国の手紙",
    cover: "https://readdy.ai/api/search-image?query=A%20woman%20in%20a%20heavy%20deep%20red%20winter%20coat%20reading%20a%20letter%20in%20a%20snowy%20village%20street%2C%20falling%20snow%20and%20warm%20window%20light%2C%20elegant%20anime%20key%20visual%2C%20cinematic%20moody%20lighting%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20highly%20detailed%20digital%20illustration%2C%20no%20text&width=600&height=900&seq=anime-cover-18&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20anime%20snowbound%20mountain%20village%20at%20dusk%2C%20crimson%20lanterns%20and%20warm%20windows%2C%20a%20single%20figure%20walking%20through%20deep%20snow%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20painterly%20detailed%20digital%20illustration%2C%20no%20text&width=1600&height=900&seq=anime-banner-18&orientation=landscape",
    synopsis: "每年初雪，她都会收到一封没有署名的信。今年，信里写着「我在车站等你」。",
    description: "北国小镇的邮局每年冬天都会收到一批无法投递的信，收件人一栏只写着「给那个人」。\n\n在东京做编辑的雪子回到故乡整理祖母遗物，意外发现了三十七封写给自己母亲的信。\n\n跨越两代人的爱情故事，用雪、信与等待，讲述那些没说出口的话如何影响了一生。",
    tags: ["爱情", "书信", "跨时代", "雪国"],
    category: "爱情",
    region: "日本",
    year: 2024,
    status: "已完结",
    episodes: 11,
    rating: 8.9,
    author: "白雪环",
    studio: "月白动画",
    updatedAt: "2026-04-16",
    views: 163700,
    featured: false,
  },
  {
    id: "thousand-year-fox",
    title: "千年狐契",
    originalTitle: "千年狐の契り",
    cover: "https://readdy.ai/api/search-image?query=An%20elegant%20fox%20spirit%20woman%20with%20white%20hair%20and%20golden%20eyes%20in%20a%20flowing%20crimson%20robe%2C%20surrounded%20by%20floating%20paper%20charms%20and%20foxfire%2C%20elegant%20anime%20key%20visual%2C%20cinematic%20moody%20lighting%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20highly%20detailed%20digital%20illustration%2C%20no%20text&width=600&height=900&seq=anime-cover-19&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20anime%20scene%20of%20a%20torii%20gate%20on%20a%20mountain%20path%20at%20night%20with%20floating%20foxfire%2C%20a%20fox%20spirit%20woman%20in%20a%20crimson%20robe%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20painterly%20detailed%20digital%20illustration%2C%20no%20text&width=1600&height=900&seq=anime-banner-19&orientation=landscape",
    synopsis: "一千年前她救下一个人类，一千年后，那个人带着同一双眼睛回来了。",
    description: "山中神社供奉着一位不愿升天的狐灵。她守着一份千年前的约定，等待着某个不会记得她的人。\n\n转世为年轻神主的少年上山赴任，对一切仪式都嗤之以鼻。直到他在旧祠堂里，看见了一幅画着自己的古画。\n\n和风奇幻代表作之一，画面华丽，情绪浓烈，关于执念与释怀。",
    tags: ["和风奇幻", "妖怪", "宿命", "爱情"],
    category: "奇幻",
    region: "日本",
    year: 2025,
    status: "连载中",
    episodes: 24,
    rating: 9.3,
    author: "狐崎夜",
    studio: "月白动画",
    updatedAt: "2026-10-13",
    views: 246900,
    featured: false,
  },
  {
    id: "blood-moon-knight",
    title: "血月骑士",
    originalTitle: "血月の騎士",
    cover: "https://readdy.ai/api/search-image?query=A%20female%20knight%20in%20ornate%20black%20and%20gold%20armor%20holding%20a%20crimson%20spear%20under%20a%20huge%20blood%20moon%2C%20elegant%20anime%20key%20visual%2C%20cinematic%20moody%20lighting%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20highly%20detailed%20digital%20illustration%2C%20no%20text&width=600&height=900&seq=anime-cover-20&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20anime%20ruined%20cathedral%20battlefield%20under%20a%20huge%20blood%20moon%2C%20a%20female%20knight%20in%20black%20and%20gold%20armor%20facing%20an%20undead%20horde%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20painterly%20detailed%20digital%20illustration%2C%20no%20text&width=1600&height=900&seq=anime-banner-20&orientation=landscape",
    synopsis: "血月升起的夜晚，死者会重新站起来。而她必须亲手斩落自己的旧友。",
    description: "王国最后的骑士团在血月之夜全军覆没，只有一人活着回来。\n\n她被赐予「血月骑士」的封号，也被赐予一项永无止境的任务：在每个月圆之夜，清理从墓地爬出的旧日同伴。\n\n黑暗奇幻的正统之作，动作场面硬朗，世界观厚重，同时保留了细腻的人物关系。",
    tags: ["黑暗奇幻", "战斗", "骑士", "女性主角"],
    category: "动作",
    region: "日本",
    year: 2026,
    status: "连载中",
    episodes: 24,
    rating: 8.8,
    author: "灰堂刃",
    studio: "赤羽制作",
    updatedAt: "2026-10-10",
    views: 154600,
    featured: false,
  },
  {
    id: "sweet-trap",
    title: "甜蜜陷阱",
    originalTitle: "スイート・トラップ",
    cover: "https://readdy.ai/api/search-image?query=A%20playful%20young%20woman%20in%20a%20dark%20red%20dress%20holding%20a%20crimson%20dessert%20plate%20in%20an%20elegant%20patisserie%2C%20mischievous%20smile%2C%20elegant%20anime%20key%20visual%2C%20cinematic%20moody%20lighting%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20highly%20detailed%20digital%20illustration%2C%20no%20text&width=600&height=900&seq=anime-cover-21&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20anime%20interior%20of%20a%20luxury%20patisserie%20at%20night%2C%20glass%20display%20of%20crimson%20desserts%2C%20warm%20gold%20lights%20and%20dark%20velvet%20seats%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20painterly%20detailed%20digital%20illustration%2C%20no%20text&width=1600&height=900&seq=anime-banner-21&orientation=landscape",
    synopsis: "她开了一家只接待失恋客人的甜品店，招牌是「会让你忘记他」的蛋糕。",
    description: "甜品师玲奈的店里有一条奇怪的规矩：每位客人只能点一份，而且必须当场吃完。\n\n传闻她的蛋糕能让人忘记一段感情，代价是也会忘记那段感情里的自己。\n\n轻喜剧外壳下包裹着温柔的成人向情感故事，节奏轻快，笑点密集，结尾意外动人。",
    tags: ["喜剧", "恋爱", "美食", "治愈"],
    category: "爱情",
    region: "韩国",
    year: 2025,
    status: "已完结",
    episodes: 12,
    rating: 8.6,
    author: "甜岛蜜",
    studio: "晴空动画",
    updatedAt: "2026-09-19",
    views: 141800,
    featured: false,
  },
  {
    id: "pillow-whisper",
    title: "枕边密语",
    originalTitle: "枕元のささやき",
    cover: "https://readdy.ai/api/search-image?query=A%20serene%20woman%20lying%20on%20a%20dark%20silk%20bed%20in%20a%20candlelit%20room%2C%20seen%20in%20soft%20profile%2C%20elegant%20anime%20key%20visual%2C%20cinematic%20moody%20lighting%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20highly%20detailed%20digital%20illustration%2C%20no%20text&width=600&height=900&seq=anime-cover-22&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20anime%20interior%20of%20a%20dim%20bedroom%20with%20heavy%20crimson%20curtains%2C%20candles%20and%20an%20open%20window%20with%20night%20air%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20painterly%20detailed%20digital%20illustration%2C%20no%20text&width=1600&height=900&seq=anime-banner-22&orientation=landscape",
    synopsis: "结婚第五年，他们开始只在关灯之后说话。",
    description: "一对结婚五年的夫妻，白天各自忙碌，夜里并肩躺着，聊一些白天不会说出口的事。\n\n关于工作、关于父母、关于曾经想要却没能拥有的生活，也关于还剩下多少喜欢。\n\n成人向情感剧，全篇几乎只有两个人和一间房，用对话与沉默撑起一段真实的婚姻切片。",
    tags: ["成人向", "婚姻", "对话剧", "情感"],
    category: "剧情",
    region: "日本",
    year: 2026,
    status: "连载中",
    episodes: 8,
    rating: 8.7,
    author: "寝待月",
    studio: "绯月映画",
    updatedAt: "2026-10-07",
    views: 93700,
    featured: false,
  },
  {
    id: "backlight-girl",
    title: "逆光少女",
    originalTitle: "逆光の少女",
    cover: "https://readdy.ai/api/search-image?query=A%20determined%20teenage%20girl%20in%20a%20dark%20school%20blazer%20standing%20against%20strong%20backlight%20in%20a%20corridor%2C%20long%20crimson%20scarf%20blowing%2C%20elegant%20anime%20key%20visual%2C%20cinematic%20moody%20lighting%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20highly%20detailed%20digital%20illustration%2C%20no%20text&width=600&height=900&seq=anime-cover-23&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20anime%20school%20corridor%20flooded%20with%20strong%20backlight%20through%20tall%20windows%2C%20a%20girl%20with%20a%20crimson%20scarf%20walking%20forward%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20painterly%20detailed%20digital%20illustration%2C%20no%20text&width=1600&height=900&seq=anime-banner-23&orientation=landscape",
    synopsis: "被全班孤立的她，决定用一场校内选举把所有人拉下水。",
    description: "转学生茜因为一封匿名举报信，成了全班排挤的对象。她没有解释，而是选择参选学生会会长。\n\n她收集每个人的把柄，也在过程中看见每个人不愿被看见的软弱。\n\n一部带刺的校园群像剧，讨论霸凌、共犯与反抗，节奏紧凑，台词锋利。",
    tags: ["校园", "群像", "成长", "反转"],
    category: "校园",
    region: "日本",
    year: 2024,
    status: "已完结",
    episodes: 13,
    rating: 9.0,
    author: "逆井光",
    studio: "晴空动画",
    updatedAt: "2026-03-28",
    views: 176200,
    featured: false,
  },
  {
    id: "night-train",
    title: "夜行列车",
    originalTitle: "夜行列車",
    cover: "https://readdy.ai/api/search-image?query=A%20mysterious%20woman%20in%20a%20dark%20travel%20coat%20sitting%20by%20the%20window%20of%20an%20old%20night%20train%2C%20crimson%20light%20outside%2C%20elegant%20anime%20key%20visual%2C%20cinematic%20moody%20lighting%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20highly%20detailed%20digital%20illustration%2C%20no%20text&width=600&height=900&seq=anime-cover-24&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20anime%20scene%20of%20an%20old%20night%20train%20crossing%20a%20snowy%20plain%20under%20a%20crimson%20moon%2C%20golden%20lit%20windows%2C%20deep%20crimson%20and%20antique%20gold%20palette%2C%20dark%20atmospheric%20background%2C%20painterly%20detailed%20digital%20illustration%2C%20no%20text&width=1600&height=900&seq=anime-banner-24&orientation=landscape",
    synopsis: "这趟列车不停靠任何已知的车站，而车上的乘客，都少了一段记忆。",
    description: "深夜十一点四十七分，末班车之后，还有一班不会出现在时刻表上的列车。\n\n失忆的少女、沉默的列车长、七位不肯说出目的地的乘客，每个人手里都有一张写着同一个终点的车票。\n\n一部氛围极佳的悬疑群像剧，以封闭空间与对话推进，真相在最后一站揭晓。",
    tags: ["悬疑", "群像", "封闭空间", "奇幻"],
    category: "悬疑",
    region: "日本",
    year: 2025,
    status: "已完结",
    episodes: 12,
    rating: 9.1,
    author: "夜野行",
    studio: "潮汐工作室",
    updatedAt: "2026-10-05",
    views: 192400,
    featured: false,
  },
];

export const categories: CategoryItem[] = [
  { name: "爱情", slug: "爱情", icon: "ri-heart-3-line", desc: "成年人的心动、犹疑与靠近" },
  { name: "奇幻", slug: "奇幻", icon: "ri-moon-clear-line", desc: "契约、妖怪与月下的世界" },
  { name: "动作", slug: "动作", icon: "ri-sword-line", desc: "刀锋、天空与不退让的人" },
  { name: "校园", slug: "校园", icon: "ri-graduation-cap-line", desc: "教室、天台与迟迟未说出口的话" },
  { name: "悬疑", slug: "悬疑", icon: "ri-search-eye-line", desc: "雾中的线索与反转的真相" },
  { name: "剧情", slug: "剧情", icon: "ri-film-line", desc: "被体面包裹的人与生活" },
  { name: "治愈", slug: "治愈", icon: "ri-cup-line", desc: "深夜书店与温热的灯光" },
];

export const regions = ["日本", "中国", "韩国"];
export const years = ["2026", "2025", "2024"];
export const statuses = ["连载中", "已完结", "剧场版"];